import Phaser from 'phaser';

export default class extends Phaser.State {
    init() {
        this.stage.backgroundColor = '#000000';
        this.stage.disableVisibilityChange = false;
        this.scale.pageAlignHorizontally = true;

        this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
        this.scale.refresh();
    }

    preload() {
        this.load.image('loader', './loader.png');
    }

    create() {
        this.state.start('Preloader');
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Boot.js
// module id = 146
// module chunks = 0